"use client";

import { HomepageDemo as HomepageDemoImpl } from "@/components/home/homepage-demo";
import { useHydrated } from "@/hooks/useHydrated";

export function HomepageDemo() {
  const hydrated = useHydrated();
  if (!hydrated) {
    return (
      <div
        id="live-demo"
        className="home-showcase-panel mx-auto max-w-6xl scroll-mt-24 px-5 py-7 sm:px-8 sm:py-9"
      >
        <div className="bg-card/70 h-[340px] animate-pulse rounded-2xl" />
      </div>
    );
  }
  return <HomepageDemoImpl />;
}
